export default __webpack_public_path__ + "static/13_jan-5a1233f4e733896a3ad28d77e3babeb9.png";